import React, { useState } from 'react'
import { useForm } from "react-hook-form"
import { Link, useNavigate } from "react-router-dom"
import { toAbsoluteUrl} from "../helpers";

function ForgotPassword() {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm()

    const [message, setMessage] = useState(null)
    const navigate = useNavigate()

    const onSubmit = async (data) => {
        setMessage(null)
        try {
            // Add your password reset logic here
            console.log("Password reset request for:", data.username)
            // After successful submission:
            // navigate('/reset-password-confirmation')
        } catch (error) {
            console.error(error)
            setMessage(error.response?.data?.error || "Request failed. Please try again.")
        }
    }

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-90 py-5">
            <div className="card shadow-lg w-100 w-md-500px">
                <div className="card-body p-10 p-lg-15">
                    {/* Logo */}
                    <div className="text-center mb-10">
                        <img
                            src={toAbsoluteUrl('media/logos/eyeconx-logo.png')}
                            alt="Logo"
                            className="h-50px mb-5"
                        />
                        <h1 className="text-dark fw-bolder mb-3">Forgot Password?</h1>
                        <div className="text-gray-500 fw-semibold fs-6">
                            Enter your username to reset your password
                        </div>
                    </div>

                    {/* Error Message */}
                    {message && (
                        <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                            <div className="d-flex flex-column">
                                <span>{message}</span>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setMessage(null)}
                                aria-label="Close"
                            ></button>
                        </div>
                    )}

                    {/* Reset Form */}
                    <form className="form w-100" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className="fv-row mb-8">
                            <label className="form-label fs-6 fw-bolder text-dark">Username</label>
                            <input
                                type="text"
                                className={`form-control form-control-lg form-control-solid ${errors.username ? 'is-invalid' : ''}`}
                                placeholder="Enter your username"
                                {...register("username", { required: "Username is required" })}
                            />
                            {errors.username && (
                                <div className="invalid-feedback">{errors.username.message}</div>
                            )}
                        </div>

                        <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                            <button
                                type="submit"
                                className="btn btn-primary me-4 px-6 py-3"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <span className="d-flex align-items-center">
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Processing...
                                    </span>
                                ) : (
                                    'Submit'
                                )}
                            </button>
                            <Link to="/login" className="btn btn-light px-6 py-3">
                                Cancel
                            </Link>
                        </div>
                    </form>

                    <div className="text-center mt-5">
                        <span className="text-gray-600 fs-6 fw-semibold">
                            Remember your password?{' '}
                            <Link to="/login" className="link-primary text-decoration-none">
                                Sign in
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword